<template>
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        :width="dialogWidth"
        :close-on-click-modal="closeOnClickingMask"
        :append-to-body="appendToBody"
    >
        <slot name="content" />
        <span v-if="isButton" slot="footer" class="dialog-footer">
            <el-button v-if="isSteps && steps > 0" size="small" @click="back()">{{ $t('button.Back') }}</el-button>
            <el-button v-if="isSteps && steps != maxSteps" size="small" @click="next()">{{ $t('button.Next') }}</el-button>
            <el-button v-if="isReset" size="small" @click="resetDialog()">{{ $t('button.Reset') }}</el-button>
            <el-button size="small" @click="cancelDialog()">{{ $t('button.Cancel') }}</el-button>
            
            <template v-if="isConfirmation == true">
                <el-popconfirm
                    class="popover-text"
                    :title="$t('dialog.AreYouSure')"
                    :confirm-button-text="$t('button.Confirm')"
                    :cancel-button-text="$t('button.Cancel')"
                    @confirm="confirm()"
                >
                    <el-button slot="reference" type="primary" size="small">{{ $t('button.Confirm') }}</el-button>
                </el-popconfirm>
            </template>
            <el-button v-else type="primary" size="small" @click="confirm()">{{ $t('button.Confirm') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: {
        isDialog: {
            type: Boolean,
            default: false,
            required: true,
        },
        title: {
            type: String,
        },
        isButton: {
            type: Boolean,
            default: true
        },
        isReset: {
            type: Boolean,
            default: false
        },
        isSteps: {
            type: Boolean,
            default: false
        },
        steps: {
            type: Number,
            default: 0
        },
        maxSteps: {
            type: Number,
            default: 0
        },
        dialogWidth: {
            default: "66%",
        },
        isAutoCloseAfterSubmit: {
            type: Boolean,
            default: true
        },
        isConfirmation: {
            type: Boolean,
            default: true
        },
        isConfirmationText: {
            type: String
        },
        closeOnClickingMask: {
            type: Boolean,
            default: true
        },
        appendToBody: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        dialogVisible: {
            get() {
                return this.isDialog;
            },
            set(value) {
                this.$emit("update:isDialog", value);
            }
        }
    },
    methods: {
        confirm() {
            this.$emit("handleConfirm");
            if (this.isAutoCloseAfterSubmit) this.dialogVisible = false;
        },
        cancelDialog() {
            this.$emit("handleCancel");
            this.dialogVisible = false;
        },
        resetDialog() {
            this.$emit("handleReset");
        },
        back() {
            this.$emit("handleBack");
        },
        next() {
            this.$emit("handleNext");
        }
    },
};
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Dialog/GeneralDialog.vue